import { render, staticRenderFns } from "./TutorsEdit.vue?vue&type=template&id=46ea9676&"
import script from "./TutorsEdit.vue?vue&type=script&lang=js&"
export * from "./TutorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports